/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TaxID = {
    format: string;
    id: string;
};
export type mutationsCreateSubscriberSetupIntentMutationVariables = {
    accountID: string;
    cardToken: string;
    taxID?: TaxID | null;
};
export type mutationsCreateSubscriberSetupIntentMutationResponse = {
    readonly createSubscriberSetupIntent: {
        readonly clientSecret: string;
    } | null;
};
export type mutationsCreateSubscriberSetupIntentMutation = {
    readonly response: mutationsCreateSubscriberSetupIntentMutationResponse;
    readonly variables: mutationsCreateSubscriberSetupIntentMutationVariables;
};



/*
mutation mutationsCreateSubscriberSetupIntentMutation(
  $accountID: ID!
  $cardToken: String!
  $taxID: TaxID
) {
  createSubscriberSetupIntent(input: {accountID: $accountID, cardToken: $cardToken, taxID: $taxID}) {
    clientSecret
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cardToken"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taxID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accountID",
            "variableName": "accountID"
          },
          {
            "kind": "Variable",
            "name": "cardToken",
            "variableName": "cardToken"
          },
          {
            "kind": "Variable",
            "name": "taxID",
            "variableName": "taxID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateSubscriberSetupIntentOutput",
    "kind": "LinkedField",
    "name": "createSubscriberSetupIntent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientSecret",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsCreateSubscriberSetupIntentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsCreateSubscriberSetupIntentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e06b8f7934d711d679110c03d598317a",
    "id": null,
    "metadata": {},
    "name": "mutationsCreateSubscriberSetupIntentMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsCreateSubscriberSetupIntentMutation(\n  $accountID: ID!\n  $cardToken: String!\n  $taxID: TaxID\n) {\n  createSubscriberSetupIntent(input: {accountID: $accountID, cardToken: $cardToken, taxID: $taxID}) {\n    clientSecret\n  }\n}\n"
  }
};
})();
(node as any).hash = '73a9a6dbd2e071cff5f3c0a334e9f764';
export default node;
